import React, { forwardRef, PropsWithChildren, ReactNode } from "react";
import MobileFooter from "../layout/MobileFooter";
import { twMerge } from "tailwind-merge";
import { ImageIcon } from "../ImageIcon";

export interface ModalV2Props {
  children: ReactNode;
  modalBoxClassName?: string;
  onClose?: () => void;
}

interface ModalV2HeaderProps {
  children: ReactNode;
  className?: string;
}

interface ModalV2BodyProps {
  children: ReactNode;
  className?: string;
}

export const ModalV2 = forwardRef<HTMLDialogElement, PropsWithChildren<ModalV2Props>>(
  ({ children, modalBoxClassName, onClose }, ref) => {
    return (
      <dialog ref={ref} className="modal scrollbar-none max-md:transition-none" onClose={onClose}>
        <div
          className={twMerge(
            "modal-box max-md:p-0 text-base-content max-md:w-full max-md:max-w-none max-md:rounded-none md:pt-0 max-md:bg-secondary bg-base-100 overflow-hidden max-md:transition-none grid grid-rows-[auto_1fr_auto] max-md:h-svh-w-fallback max-md:pt-[env(safe-area-inset-top)]",
            modalBoxClassName ?? ""
          )}
        >
          {children}
        </div>
      </dialog>
    );
  }
);

export function ModalV2BackButton() {
  return (
    <form method="dialog" className="flex items-center gap-2">
      <button className="btn btn-primary btn-ghost text-primary-content">
        <ImageIcon
          className="w-[calc(var(--size)*0.5)] h-[calc(var(--size)*0.5)]"
          src="/assets/images/chevron_left_white_square.png"
        />
      </button>
    </form>
  );
}

export function ModalV2Header({ children, className = "" }: ModalV2HeaderProps) {
  return (
    <div
      className={twMerge(
        "md:-mx-6 px-4 bg-secondary text-secondary-content max-md:h-20",
        className
      )}
    >
      {children}
    </div>
  );
}

export function ModalV2Body({ children, className = "" }: ModalV2BodyProps) {
  return (
    <div className={twMerge(`flex flex-col gap-2 overflow-y-auto`, className)}>{children}</div>
  );
}
